import { render, staticRenderFns } from "./AnalyticsOrdersChart.vue?vue&type=template&id=79d98928&scoped=true&"
import script from "./AnalyticsOrdersChart.vue?vue&type=script&lang=js&"
export * from "./AnalyticsOrdersChart.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsOrdersChart.vue?vue&type=style&index=0&id=79d98928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d98928",
  null
  
)

export default component.exports